import axios from 'axios';
import apiClient from '../ApiClient';

const UserService = {
    getUser:async (params) => {
    try {
      return (await apiClient.get('/users', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      return null;
    }
  },
  getUserModules:async (params) => {
    try {
      return (await apiClient.get('/modules', params)).data;
    } catch (error) {
      console.error('Error fetching modules:', error);
      return null;
    }
  },
  getUserMe:async (params) => {
    try {
      return (await apiClient.get('/me', params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      return null;
    }
  },
  addUser:async (params) => {
    try {
      return (await apiClient.post('/users',params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      return null;
    }
  },
  updateUser:async (params) => {
    try {
      return (await apiClient.patch(`/users/${params?.UserID}`,params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      return null;
    }
  },
  updateUserAcc:async (params, UserID) => {
    try {
      return (await apiClient.patch(`/users/${UserID}`,params)).data;
    } catch (error) {
      console.error('Error fetching users:', error);
      return null;
    }
  },
  deleteUser:async (params) => {
    try {
      return (await apiClient.delete(`/users/${params?.UserID}`));
    } catch (error) {
      console.error('Error fetching users:', error);
      return null;
    }
  },
};

export default UserService;
